import styled from 'styled-components'
import ContentDivider from "../../components/molecules/contentDivider";
import ContentContainer from "../../components/atoms/ContentContainer";
import Aside from "../../components/atoms/Aside";
import H1 from "../../components/atoms/H1";
import P from "../../components/atoms/P";
import Div from "../../components/atoms/Div";
import FlexDiv from "../../components/atoms/FlexDiv";
import Span from "../../components/atoms/Span";
import {GraphQlIcon, MagentoIcon, NextJsIcon, ReactJsIcon} from "../../components/svgs/TechnologyIcons";

export default function SupportedTechnology() {
	return (
		<StyledSupportedTechnology id={'technology'}>
			<ContentDivider fillColour={'#30323D'}/>
			<ContentContainer>
				<Aside>
					technology
				</Aside>
				<H1 color={'var(--white)'} margin={'24px 0 0 0'}>
					A Technology Powerhouse
				</H1>
				<P color={'var(--white)'}>
					Driven by Magento and built with the most powerful technology available,
					Aloe storefront modernises your technology stack and quickly elevates your
					brand to meet the customer where they are.
				</P>
				<Div
					backgroundColor={'var(--white)'}
					width={'100%'} height={'363px'}
					margin={'72px 0 0 0'}
					borderRadius={'24px'}
					boxShadow={'2px 2px 20px rgba(0, 0, 0, 0.08), 0px 0px 30px rgba(0, 0, 0, 0.04)'}
					padding={'52px 72px'}
				>
					<TechnologyGrid>
						<TechnologyGridItem
							icon={'graphql'}
							title={'GraphQl'}
							text={'GraphQL is a modern query language for APIs and a runtime for fulfilling those queries with your existing data. It’s fast.'}
						/>
						<TechnologyGridItem
							icon={'magento'}
							title={'Magento'}
							text={'Magento is a leading very flexible platform that powers some of the largest ecommerce systems in the world.'}
						/>
						<TechnologyGridItem
							icon={'nextjs'}
							title={'Next JS'}
							text={'Next.js is an open-source development framework built on top of Node.js enabling functionalities such as server-side rendering and generating static websites.'}
						/>
						<TechnologyGridItem
							icon={'reactjs'}
							title={'ReactJS'}
							text={'React is an open-source front-end JavaScript library for building user interfaces It is maintained by Facebook and a community of individual developers and companies.'}
						/>
					</TechnologyGrid>
				</Div>
			</ContentContainer>
		</StyledSupportedTechnology>
	)
}

const StyledSupportedTechnology = styled.div`
  	position: relative;
  	height: 1051px;
  	background-color: var(--dark);
`

const TechnologyGrid = styled.div`
  	width: 100%;
  	height: 100%;
  	display: grid;
  	grid-column-gap: 200px;
  	grid-template-columns: repeat(2, 1fr);
`

function TechnologyGridItem({icon, title, text}) {
	return (
		<FlexDiv alignItems={'center'}>
			<Div width={'66px'} height={'66px'} margin={'0 20px 0 0'}>
				{icon === 'graphql' && <GraphQlIcon />}
				{icon === 'magento' && <MagentoIcon />}
				{icon === 'nextjs' && <NextJsIcon />}
				{icon === 'reactjs' && <ReactJsIcon />}
			</Div>
			<Div>
				<Span type={'secondary'} fontWeight={'bold'}>
					{title}
				</Span>
				<Span type={'secondary'} margin={'6px 0 0 0'} fontSize={'15px'}>
					{text}
				</Span>
			</Div>
		</FlexDiv>
	)
}